type Props = {
  label: string;
  testId?: string;
};

export const SectionHeader = ({ label, testId }: Props) => (
  <p
    data-testid={testId}
    className="text-xs font-semibold uppercase tracking-wide text-foreground-subtle"
  >
    {label}
  </p>
);
